import gql from 'graphql-tag'

export default gql`
query listActiveMediaForCashRegister($cashRegisterId: ID!, $date: Date, $time: Time) {
	cashAssist {
		listActiveMediaForCashRegister(cashRegisterId: $cashRegisterId, date: $date, time: $time) {
			id
			mod_ver
			name
			img16_9 {
				uid
	      		key
	    	}
		}
	}
}
`

